import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { featuredTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-cream border-y border-silver-light" data-id="element-242" data-mp="3sq1whyi8a21r">
      <div className="max-w-7xl mx-auto px-4" data-id="element-243" data-mp="3ssemmyy53ipw">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-244" data-mp="3nzbnmbalfh2b">
          {featuredTestimonials.map((testimonial, index) => <motion.div key={testimonial.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-silver-light p-6 rounded-2xl flex flex-col" data-id="element-245" data-mp="5kauxcl9kgzq" data-mpi={index}>
              <div className="flex gap-1 text-brand mb-4" aria-hidden="true" data-id="element-246" data-mp="2hby3ovndmjya">
                {[...Array(5)].map((_, star) => <Star key={star} size={16} fill="currentColor" data-id="element-247" data-mp="2ce4zu99jq216" data-mpi={star} />)}
              </div>
              <p className="text-graphite italic mb-6 text-sm leading-relaxed" data-id="element-248" data-mp="caw8c3j4c112">
                &ldquo;{testimonial.text}&rdquo;
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-249" data-mp="ld5l701v06hm">
                <div className="w-10 h-10 rounded-full bg-brand-soft border border-brand/40 flex items-center justify-center text-brand-dark font-bold" data-id="element-250" data-mp="q441w0qrf6le">
                  {testimonial.initials}
                </div>
                <div data-id="element-251" data-mp="101s7xmttg0iv">
                  <div className="font-bold text-ink text-sm" data-id="element-252" data-mp="1018rybnq7m7h">{testimonial.name}</div>
                  <div className="text-xs text-brand-dark" data-id="element-253" data-mp="143n7als6s3u0">{testimonial.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}